import request from '@/utils/request'

let EnterpriseApi = {

  /*企业列表*/
  list(data) {
    return request._post('/shop/plus.enterprise.Index/index', data);
},
  listx(data) {
    return request._post('/shop/plus.enterprise.Index/indexx', data);
},

  situationlist(data) {
    return request._post('/shop/plus.enterprise.Situation/index', data);
},
  productlist(data) {
    return request._post('/shop/plus.enterprise.Product/index', data);
},
delproduct(data){
  return request._post('/shop/plus.enterprise.Product/del', data);
},
editProduct(data){
     return request._post('/shop/plus.enterprise.Product/edit', data);
},

addsituation(data){
    return request._post('/shop/plus.enterprise.Situation/add', data);
},
detailproduct(data){
    return request._post('/shop/plus.enterprise.Product/detail', data);
},
  noticelist(data) {
    return request._post('/shop/plus.enterprise.Notice/index', data);
},
addnotice(data){
    return request._post('/shop/plus.enterprise.Notice/add', data);
},
editNotice(data) {
    return request._post('/shop/plus.enterprise.Notice/edit', data);
},
detailnotice(data){
    return request._post('/shop/plus.enterprise.Situation/detail', data);
},


editSituation(data) {
    return request._post('/shop/plus.enterprise.Situation/edit', data);
},
delnotice(data) {
    return request._post('/shop/plus.enterprise.Notice/delnotice', data);
},
detailaddsituation(data) {
    return request._post('/shop/plus.enterprise.Situation/detail', data);
},
listx(data) {
    return request._post('/shop/plus.enterprise.Index/indexx', data);
},
getCoreMembers(data){
     return request._post('/shop/plus.core_members.Index/index', data);
},
deleteCoreMember(data){
     return request._post('/shop/plus.core_members.Index/del', data);
},
updateCoreMember(data){
    return request._post('/shop/plus.core_members.Index/edit', data);
},
addCoreMember(data){
    return request._post('/shop/plus.core_members.Index/add', data);
},
/*添加企业*/
add(data) {
    return request._post('/shop/plus.enterprise.Index/add', data);
},
/*修改企业*/
edit(data) {
    return request._post('/shop/plus.enterprise.Index/edit', data);
},
/*删除企业*/
del(data) {
    return request._post('/shop/plus.enterprise.Index/del', data);
},
delsituation(data) {
    return request._post('/shop/plus.enterprise.Situation/del', data);
},
/*企业详情*/
detail(data) {
  return request._post('/shop/plus.enterprise.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.enterprise.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.enterprise.Setting/getSetting', data, errorback);
    },
}
export default EnterpriseApi;



// WEBPACK FOOTER //
// ./src/api/enterprise.js